import { render, staticRenderFns } from "./ReportsOfficer.vue?vue&type=template&id=b8de7038"
import script from "./ReportsOfficer.vue?vue&type=script&lang=js"
export * from "./ReportsOfficer.vue?vue&type=script&lang=js"
import style0 from "./ReportsOfficer.vue?vue&type=style&index=0&id=b8de7038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports